
import { Component, Vue, Prop } from "vue-property-decorator";

import moment from "moment";
moment.locale("es");

@Component({
  components: {
    DoughnutGraph: () => import("@/components/DoughnutGraph.vue")
  },
  computed: {},
  filters: {},
  watch: {
    GraphsData(newVal, oldVal) {
      (this as any).initGraphs(newVal);
    }
  }
})
export default class RequestsGraphs extends Vue {
  @Prop(Object) readonly GraphsData;
  @Prop(Function) readonly seeMoreRequestsOperations;
  iconExpanded: string = require("@/assets/ico-expand.svg");
  iconCollapsed: string = require("@/assets/ico-collapse.svg");
  databoxes: any = {
    requestsState: {
      isExpanded: false,
      svgPath: this.iconExpanded
    }
  };
  data: any = {
    requestsState: {
      labels: [],
      datasets: {
        backgroundColor: ["#32AE80", "#F3C911", "#DC5A57"],
        data: []
      }
    },
    lastOperations: []
  };
  async mounted() {
    await this.initGraphs(this.GraphsData);
  }

  async initGraphs(newVal) {
    if (!newVal) return;
    this.data.requestsState.datasets.data.push(newVal.requestsApproved);
    this.data.requestsState.datasets.data.push(newVal.requestsPending);
    this.data.requestsState.datasets.data.push(newVal.requestsRejected);
    this.data.requestsState.labels.push("Activas");
    this.data.requestsState.labels.push("Pendientes");
    this.data.requestsState.labels.push("No Procesadas");
    this.data.lastOperations = newVal.requestsLastOperations.map(req => ({
      operation: req.content,
      nombre: req.admin.fullname || req.subscriptor.fullname,
      fecha: moment(req.createdAt).format("DD/MM/YYYY")
    }));
  }

  toggleExpand(index) {
    this.databoxes[index].isExpanded = !this.databoxes[index].isExpanded;
    if (this.databoxes[index].isExpanded)
      this.databoxes[index].svgPath = this.iconCollapsed;
    else this.databoxes[index].svgPath = this.iconExpanded;

    this.$forceUpdate();
  }
}
